import React, { useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Modal from "react-modal";
import Navbar from "./components/molecules/Navbar/Navbar";
import Homepage from "./components/pages/Homepage/Homepage";
import About from "./components/pages/About/About";
import Agents from "./components/pages/Agents/Agents";
import Contacts from "./components/pages/Contacts/Contacts";
import Listings from "./components/pages/Listings/Listings";
import Dashboard from "./components/pages/Dashboard/Dashboard";
import Edit from "./components/pages/Dashboard/DashComponents/Edit/Edit";
import AddNew from "./components/pages/Dashboard/DashComponents/AddNew/AddNew";
import AgentList from "./components/pages/Dashboard/DashComponents/AgentList/AgentList";
import Bookings from "./components/pages/Dashboard/DashComponents/Bookings/Bookings";
import MyListings from "./components/pages/Dashboard/DashComponents/MyListings/MyListings";
import Message from "./components/pages/Dashboard/DashComponents/Message/Message";
import Reviews from "./components/pages/Dashboard/DashComponents/Reviews/Reviews";
import SubMenu from "./components/pages/Dashboard/DashComponents/SubMenu/SubMenu";
import DashboardHome from "./components/pages/Dashboard/DashComponents/DashboardHome/DashboardHome";
import Login from "./components/atoms/Login/Login";
import Register from "./components/atoms/Register/Register";
import AgentSingle from "./components/pages/AgentSingle/AgentSingle";
import Success from "./components/atoms/Success/Success";
import ListSingle from "./components/pages/ListSingle/ListSingle";
import Transaction from "./components/pages/Dashboard/DashComponents/Transaction/Transaction";
import Coperate from "./components/pages/Dashboard/DashComponents/Application/Coperate";
import Individual from "./components/pages/Dashboard/DashComponents/Application/Individual";

Modal.setAppElement("#root");

const App = () => {
  const [showMenu, setShowMenu] = useState(true);
  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" exact element={<Homepage />} />
        <Route path="login" element={<Login />} />
        <Route path="register" element={<Register />} />
        <Route path="about" element={<About />} />
        <Route path="agents" element={<Agents />} />
        <Route path="contacts" element={<Contacts />} />
        <Route path="listings" element={<Listings />} />
        <Route path="agentsingle" element={<AgentSingle />} />
        <Route path="account-success" element={<Success />} />
        <Route path="property/:slug" element={<ListSingle />} />
        <Route
          path="dashboard"
          element={<Dashboard showMenu={showMenu} toggleMenu={toggleMenu} />}
        >
          <Route
            path="dashboard-home"
            element={
              <DashboardHome toggleMenu={toggleMenu} showMenu={showMenu} />
            }
          />
          <Route
            path="transaction"
            element={
              <Transaction toggleMenu={toggleMenu} showMenu={showMenu} />
            }
          />
          <Route
            path="edit"
            element={<Edit toggleMenu={toggleMenu} showMenu={showMenu} />}
          />
          <Route
            path="message"
            element={<Message toggleMenu={toggleMenu} showMenu={showMenu} />}
          />
          <Route
            path="add-new"
            element={<AddNew toggleMenu={toggleMenu} showMenu={showMenu} />}
          />
          <Route path="property/:slug/edit" element={<AddNew />} />
          <Route
            path="agent-list"
            element={<AgentList toggleMenu={toggleMenu} showMenu={showMenu} />}
          />
          <Route
            path="individual_application"
            element={<Individual toggleMenu={toggleMenu} showMenu={showMenu} />}
          />
          <Route
            path="coperate_application"
            element={<Coperate toggleMenu={toggleMenu} showMenu={showMenu} />}
          />
          <Route
            path="bookings"
            element={<Bookings toggleMenu={toggleMenu} showMenu={showMenu} />}
          />
          <Route
            path="my-listings"
            element={<MyListings toggleMenu={toggleMenu} showMenu={showMenu} />}
          />
          <Route
            path="reviews"
            element={<Reviews toggleMenu={toggleMenu} showMenu={showMenu} />}
          />
          <Route path="sub-menu" element={<SubMenu />} />
        </Route>
      </Routes>
      {/* <Modal isOpen={modalIsOpen}>
          <h2>Modal Title</h2>
          <p>Modal Body</p>
          <button onClick={() => setIsOpen(true)}>Open Btn</button>
        </Modal> */}
    </Router>
  );
};

export default App;
